import * as React from 'react';
import { FC, useState } from 'react';
import UserPanel from 'moduleBase/components/header/user-panel/UserPanel';
import SvgSprite from 'src/react/components/html-elements/SvgSprite';
import { UserMenu } from 'moduleBase/types/Menu';
import MobileNav from 'moduleBase/modules/menu/containers/MobileNav';
import { Collapse } from 'react-bootstrap';
import Logo from 'images/logo.svg';
import { When } from 'react-if';
import CartNotifier from 'moduleCartNotifier/containers/CartNotifier';
import { Link } from 'components/router/Link';
import { Avatar } from 'ui/avatar/Avatar';
import { useUserData } from 'components/user/hooks/use-user-data';
import Notifier from 'moduleChatNotifier/containers/Notifier';

type HeaderProps = {
  userMenu: UserMenu,
}

const MobileHeader: FC<HeaderProps> = ({
  userMenu,
}) => {
  const userData = useUserData();

  const [isVisibleMenuPanel, setIsVisibleMenuPanel] = useState(false);
  const [isVisibleUserPanel, setIsVisibleUserPanel] = useState(false);

  const userPanelShow = () => {
    setIsVisibleUserPanel(!isVisibleUserPanel);
    document.body.classList.toggle('body-fixed');
    if (isVisibleMenuPanel) {
      setIsVisibleMenuPanel(false);
      document.body.classList.add('body-fixed');
    }
  };

  const menuPanelShow = () => {
    setIsVisibleMenuPanel(!isVisibleMenuPanel);
    document.body.classList.toggle('body-fixed');
    if (isVisibleUserPanel) {
      setIsVisibleUserPanel(false);
      document.body.classList.add('body-fixed');
    }
  };

  // noinspection HtmlUnknownTarget
  return (
    <div>
      <header className="site-header">
        <div className="container container-lg-fluid">
          <div className="d-flex align-items-center">
            <button
              className="site-header__menu-toggle btn btn-square collapsed"
              type="button"
              onClick={menuPanelShow}
            >
              <SvgSprite id="menu-open" size={16} />
            </button>
            <Link to="/" className="mr-16p">
              <img src={Logo} className="img-fluid" />
            </Link>
            <div className="mr-16p ml-auto">
              <Notifier />
            </div>
            <When condition={userData.isCustomer}>
              <CartNotifier />
            </When>
            <button
              className="site-header__user-panel-toggle btn rounded-circle collapsed"
              type="button"
              onClick={userPanelShow}
            >
              <Avatar image={userData.avatar.image} sizeSm />
            </button>
          </div>
        </div>
      </header>
      <Collapse in={isVisibleMenuPanel}>
        <div className="menu-panel shadow-bottom">
          <MobileNav
            hide={() => {
              setIsVisibleMenuPanel(false);
              document.body.classList.remove('body-fixed');
            }}
          />
        </div>
      </Collapse>
      <UserPanel
        isVisible={isVisibleUserPanel}
        userMenu={userMenu}
        hide={() => {
          setIsVisibleUserPanel(false);
          document.body.classList.remove('body-fixed');
        }}
      />
    </div>
  );
};

export default MobileHeader;
